































import { Vue, Component } from 'vue-property-decorator';
import UserModule from '@/store/modules/user';
import LifecycleModule from '@/store/modules/lifecycle';
import Card from '@/components/Card/StandardCard/index.vue';
import SubmissionCard from '@/components/Card/SubmissionCard/index.vue';
import { UnitsApi, EventsApi } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import { FWAccessControl } from '../../util/AccessControlUtil';

@Component({
  components: {
    Card,
    SubmissionCard,
  },
})
export default class LoginView extends Vue {
  get userFullname() {
    const user = UserModule.currentUser;
    if (user && user.name && user.name.first && user.name.last) {
      return `${user.name.first} ${user.name.last}`;
    }
    return '';
  }

  get partnerStatus() {
    // TODO: REPLACE LOGIC
    // if (UserModule.currentPartner) {
    //   return UserModule.currentPartner.status;
    // }
    return null;
  }

  async mounted() {
    try {
      const x = new UnitsApi(AppModule.apiConfig);
      const eventsApi = new EventsApi(AppModule.apiConfig);
    } catch (err) {
      console.log(err);
    }
  }

  public async logout() {
    LifecycleModule.terminate();
    this.$router.push('/login');
  }
}
